module.exports = __webpack_public_path__ + "img/marca.3455cef0.svg";